/* eslint-disable */
import PropTypes from "prop-types";

function ParcelCard(props) {
  const {
    parcel,
  } = props;  
    
return (
    <ul className="list-unstyled employee-requests__card">
      <li>
        <span className="bold">القرية: </span>
        {parcel.VELL_NAME}
      </li>
      <li>
        <span className="bold">الحوض: </span>
        {parcel.HOD_NAME}
      </li>
      <li>
        <span className="bold">رقم القطعة: </span>
        {parcel.PARCEL_ID}
      </li>
      <li>
        <span className="bold">رقم المفتاح: </span>
        {parcel.DLS_KEY}
      </li>
      {parcel.landUse && (
        <li>
          <span className="bold">إستخدامات الأرض: </span>
          {parcel.landUse}
        </li>
      )}
    </ul>
  );
}

ParcelCard.defaultProps = {
  lockParcel: null,
};

ParcelCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  parcel: PropTypes.object.isRequired,
  canPrint: PropTypes.bool.isRequired,
  canDisablePdf: PropTypes.bool.isRequired,
  togglePrint: PropTypes.func.isRequired,
};

export default ParcelCard;
